import React from "react";
import Logo from "../logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { getAuth, signOut } from "firebase/auth";
import { Box, Flex, HStack, Button, Text, Avatar, Spacer } from "@chakra-ui/react";

function Navbar() {
  const { user, role } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isSuperUser = user?.email === "shabanharuna100@gmail.com";
  const isPublicPage = ["/", "/login", "/register", "/signup"].includes(location.pathname);
  const showAdmin = role === "admin" || isSuperUser;

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <Box
      as="nav"
      position="fixed"
      top={0}
      left={0}
      w="100%"
      zIndex={1000}
      bg="whiteAlpha.95"
      boxShadow="sm"
      borderBottom="1.5px solid #e2e8f0"
      fontFamily="Poppins, Inter, sans-serif"
      fontSize={{ base: "md", md: "lg" }}
      px={{ base: 4, md: 10 }}
      py={3}
    >
      <Flex align="center" maxW="1200px" mx="auto">
        <Link to="/" style={{ textDecoration: "none" }}>
          <HStack spacing={2}>
            <img src={Logo} alt="Serena Logo" style={{ height: 32, width: 32 }} />
            <Text color="green.700" fontWeight="bold" fontSize="xl" letterSpacing="tight">
              Serena Space
            </Text>
          </HStack>
        </Link>
        <Spacer />
        <HStack spacing={4} align="center">
          {isPublicPage && (
            <>
              <Link to="/login">
                <Button variant="ghost" colorScheme="green" fontWeight="bold">Login</Button>
              </Link>
              <Link to="/register">
                <Button variant="outline" colorScheme="green" fontWeight="bold">Register</Button>
              </Link>
            </>
          )}
          {!isPublicPage && user && (
            <>
              <HStack spacing={2}>
                <Avatar size="sm" name={user.displayName || user.email} />
                <Text fontWeight="semibold" color="gray.700">
                  {user.displayName || user.email}
                  {isSuperUser && (
                    <Text as="span" color="orange.400" fontWeight="bold" ml={2}>(Super Admin)</Text>
                  )}
                </Text>
              </HStack>
              <Link to="/user/dashboard">
                <Button variant="ghost" colorScheme="green" fontWeight="bold">Dashboard</Button>
              </Link>
              {showAdmin && (
                <>
                  <Link to="/admin/dashboard">
                    <Button variant="ghost" colorScheme="orange" fontWeight="bold">Admin</Button>
                  </Link>
                  <Link to="/admin/kitchen">
                    <Button variant="ghost" colorScheme="orange" fontWeight="bold">Kitchen</Button>
                  </Link>
                </>
              )}
              <Button onClick={handleLogout} colorScheme="red" fontWeight="bold" borderRadius="xl">
                Logout
              </Button>
            </>
          )}
        </HStack>
      </Flex>
    </Box>
  );
}

export default Navbar;
